module.exports = __webpack_public_path__ + "assets/img/login.1dbd2f47.svg";